import {
  AttachedTicketIcon,
  EmailIcon,
  MoneyPaperIcon,
  Typography,
  UsersIcon,
  Work2Icon,
} from "@cpj-ai/panel-npm-package";
import CredentialsTab from "./Tabs/CredentialsTab";
import EmployeesTab from "./Tabs/EmployeesTab";
import JobPositionTab from "./Tabs/JobPositionTab";
import CPJMessagesTabContent from "./Tabs/MessagesTab";
import PaymentsTab from "./Tabs/PaymentsTab";
export const getCompanyDetailTabsConfigs = (activeTab: string, refetchCompanyDetail: () => void, id?: string) => {
  return [
    // {
    //   title: (
    //     <div className="flex items-center gap-1">
    //       <StackoverflowIcon width={24} height={24} stroke={activeTab === "overview" ? "#C71F2C" : "#3F3F46"} />
    //       <Typography className="text-xs">Overview</Typography>
    //     </div>
    //   ),
    //   content: <div>Overview</div>,
    //   key: "overview",
    // },
    {
      title: (
        <div className="flex items-center gap-1">
          <Work2Icon width={24} height={24} fill={activeTab === "job-position" ? "#C71F2C" : "#3F3F46"} />
          <Typography className="text-xs">Job Post</Typography>
        </div>
      ),
      content: <JobPositionTab />,
      key: "job-position",
    },
    {
      title: (
        <div className="flex items-center gap-1">
          <AttachedTicketIcon width={24} height={24} stroke={activeTab === "credentials" ? "#C71F2C" : "#3F3F46"} />
          <Typography className="text-xs">Credentials</Typography>
        </div>
      ),
      content: <CredentialsTab refetch={refetchCompanyDetail} />,
      key: "credentials",
    },
    {
      title: (
        <div className="flex items-center gap-1">
          <UsersIcon width={24} height={24} fill={activeTab === "employees" ? "#C71F2C" : "#3F3F46"} />
          <Typography className="text-xs">Employees</Typography>
        </div>
      ),
      content: <EmployeesTab />,
      key: "employees",
    },
    {
      title: (
        <div className="flex items-center gap-1">
          <MoneyPaperIcon width={24} height={24} stroke={activeTab === "payments" ? "#C71F2C" : "#3F3F46"} />
          <Typography className="text-xs">Payments</Typography>
        </div>
      ),
      content: <PaymentsTab />,
      key: "payments",
    },
    {
      title: (
        <div className="flex items-center gap-1">
          <EmailIcon width={24} height={24} stroke={activeTab === "messages" ? "#C71F2C" : "#3F3F46"} />
          <Typography className="text-xs">Messages</Typography>
        </div>
      ),
      content: <CPJMessagesTabContent employeeId={id} />,
      key: "messages",
    },
  ];
};
